var textDark = '#262729';
var textDarkTransparent = 'rgba(38, 39, 41, 0.6)';
var textLight = '#ffffff';
var textLightTransparent = 'rgba(255, 255, 255, 0.6)';
var theme = {
    global: {
        baseFontSize: '16px',
        borderRadius: '3px',
        breakpoints: {
            mobile: '660px',
            tablet: '768px',
            desktop: '1024px',
        },
        fonts: {},
        maxWidth: '1140px',
        spacer: {
            small: '0.5rem',
            medium: '1rem',
            large: '2rem',
        },
        color: {
            textDark: textDark,
            textDarkTransparent: textDarkTransparent,
            textLight: textLight,
            textLightTransparent: textLightTransparent,
        },
    },
    base: {
        color: {
            normal: '#ffffff',
            text: textDark,
            textTransparent: textDarkTransparent,
        },
        font: {
            normal: {
                family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
                weight: '400',
            },
            bold: {
                family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
                weight: '600',
            },
        },
    },
    primary: {
        color: {
            normal: '#17616f',
            text: textLight,
            textTransparent: textLightTransparent,
        },
        font: {
            normal: {
                family: 'Open Sans',
                weight: '400',
            },
            bold: {
                family: 'Open Sans',
                weight: '600',
            },
        },
    },
    secondary: {
        color: {
            normal: '#c75858',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    additional: {
        color: {
            normal: '#489fdf',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    greyLight: {
        color: {
            normal: '#eef3f7',
            text: textDark,
            textTransparent: textDarkTransparent,
        },
    },
    greyNormal: {
        color: {
            normal: '#b1b4b7',
            text: textDark,
            textTransparent: textDarkTransparent,
        },
    },
    greyDark: {
        color: {
            normal: '#4e5051',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    sale: {
        color: {
            normal: '#b71739',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    error: {
        color: {
            normal: '#d0021b',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    info: {
        color: {
            normal: '#c7cccf',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    success: {
        color: {
            normal: '#7dae2e',
            text: textLight,
            textTransparent: textLightTransparent,
        },
    },
    warning: {
        color: {
            normal: '#f5a623',
            text: textDark,
            textTransparent: textDarkTransparent,
        },
    },
    component: {},
};
export default theme;
//# sourceMappingURL=index.js.map